var VERSION = 1789888786567

export  {
	VERSION
} 
